import {initialState, initialMutations, initialActions} from "../common_store";
import Http from 'axios';
import {VERSIONED_API_URL} from "../../../config/config";
// initialState = JSON.parse(JSON.stringify(initialState));
// initialActions = Object.assign({},initialActions);
// initialMutations = Object.assign({},initialMutations);
let defaultState = {
    url_name: 'ad-report'
};

defaultState = {...initialState, ...defaultState, airlines:[]};
defaultState = JSON.parse(JSON.stringify(defaultState));

const getters = {
    reportLoading: state => state.loading,
    airlines: state => state.airlines
};

let actions = {...initialActions,
fetchAirlines({commit}){
    Http.get(`${VERSIONED_API_URL}/airlines-all`)
        .then((res) => {
            commit("setAirlines", res.data);
        })
}};
// actions = JSON.parse(JSON.stringify(actions));
let mutations = {...initialMutations,
setAirlines(state,items) {
    state.airlines = items;
}};
// mutations = JSON.parse(JSON.stringify(mutations));

export default {
    namespaced: true,
    state: defaultState,
    getters,
    actions,
    mutations
}
